import React, { useState, useEffect } from "react";
import "./Testimonial.css";

const testimonialsData = [
  {
    id: 1,
    type: "video",
    name: "Nadeesha",
    role: "Mother • Normal Delivery",
    rating: 5,
    message:
      "I came to Lakshmi Maternity Home for my delivery under the care of Dr. Nishitha Rao, and it was the best decision I made. The doctors and staff provided excellent care, ensuring my comfort and well-being throughout the process. Their expertise, frequent check-ups, and compassionate support made my experience smooth and reassuring. I am truly grateful for the outstanding care I received and highly recommend Lakshmi Maternity Home.",
    videoUrl: "https://www.youtube.com/embed/OCzlMZpt88E?rel=0",
    isShort: true
  },
  {
    id: 2,
    type: "video",
    name: "Shruthi",
    role: "Mother • Comprehensive Maternity Care",
    rating: 5,
    message:
      "I started my pregnancy care at Lakshmi Maternity Home under Dr. Nishitha Rao, and I couldn't have asked for a better experience. The level of care and attention I received throughout my pregnancy was outstanding. The doctors ensured my well-being with regular visits, thorough explanations of scans, and quick lab results. Their dedication and expertise made me feel safe and confident throughout my delivery.",
    videoUrl: "https://www.youtube.com/embed/iSNwDrwJCXQ?rel=0",
    isShort: false
  },
  {
    id: 3,
    type: "text",
    name: "Priya Sharma",
    role: "Mother • Normal Delivery",
    rating: 5,
    message:
      "Dr. Nishita was amazing! She made sure I felt comfortable and safe throughout my pregnancy. I had a normal delivery, and everything went smoothly. The nursing staff was so helpful, and the hospital made me feel right at home. I highly recommend Lakshmi Maternity & Surgical Centre for safe and gentle delivery.",
    videoUrl: null
  },
  {
    id: 4,
    type: "text",
    name: "Rahul Kumar",
    role: "Husband / Father • Maternity Care",
    rating: 5,
    message:
      "My wife had a normal delivery at Lakshmi Maternity. The hospital was great! The staff was friendly, and we felt very well taken care of from day one. The doctors were supportive, and we were happy with the whole experience. If you're looking for a safe place for maternity care, this is it.",
    videoUrl: null
  },
  {
    id: 5,
    type: "text",
    name: "Simran Patel",
    role: "Mother • Prenatal to Postnatal Care",
    rating: 5,
    message:
      "I had a wonderful experience at Lakshmi Maternity & Surgical Centre. Dr. Nishita guided me through everything, and I had a safe normal delivery. The hospital’s support was amazing, and I felt very comfortable throughout my stay. I would recommend this hospital to anyone looking for trusted maternal care.",
    videoUrl: null
  },
  {
    id: 6,
    type: "text",
    name: "Vikas Desai",
    role: "Father • Normal Delivery Experience",
    rating: 5,
    message:
      "I'm so glad we chose Lakshmi Maternity for my wife's delivery. The hospital is truly one of the best for normal delivery in Bangalore. They made sure my wife felt comfortable, and the doctors were very experienced. If you're looking for warm, affordable maternity care, this is the place.",
    videoUrl: null
  },
  {
    id: 7,
    type: "text",
    name: "Nisha Reddy",
    role: "Mother • Maternity & Surgical Care",
    rating: 5,
    message:
      "Lakshmi Maternity is hands down the best maternity hospital in Bangalore. The hospital provided safe delivery services, and the care I received was outstanding. The staff made sure everything went smoothly, and I felt so supported. I'll definitely recommend it to other expecting mothers!",
    videoUrl: null
  }
];

export default function Testimonials() {
  const [filter, setFilter] = useState("all");
  const [currentIndex, setCurrentIndex] = useState(0);

  const filteredStories = testimonialsData.filter((item) => {
    if (filter === "video") return item.type === "video";
    if (filter === "text") return item.type === "text";
    return true;
  });

  const cardsPerPage = 2;
  const totalPages = Math.ceil(filteredStories.length / cardsPerPage);

  // Reset page when filter changes
  useEffect(() => {
    setCurrentIndex(0);
  }, [filter]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : totalPages - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev < totalPages - 1 ? prev + 1 : 0));
  };

  const currentStories = filteredStories.slice(
    currentIndex * cardsPerPage,
    currentIndex * cardsPerPage + cardsPerPage
  );

  return (
    <section className="testimonials-section band" id="testimonials">
      <div className="wrap">
        <div className="testimonials-header">
          <div>
            <p className="eyebrow">Patient stories</p>
            <h2 className="h-sec">Words from families we have cared for.</h2>
            <p className="lede" style={{ marginTop: "12px", maxWidth: "720px" }}>
              Real experiences and heartfelt feedback from mothers and families who welcomed their babies at Lakshmi Maternity &amp; Surgical Centre.
            </p>
          </div>

          {/* Filter Pills */}
          <div className="testimonials-filter-bar">
            <button
              type="button"
              className={`filter-btn ${filter === "all" ? "active" : ""}`}
              onClick={() => setFilter("all")}
            >
              All Stories ({testimonialsData.length})
            </button>
            <button
              type="button"
              className={`filter-btn ${filter === "video" ? "active" : ""}`}
              onClick={() => setFilter("video")}
            >
              Video Stories (2)
            </button>
            <button
              type="button"
              className={`filter-btn ${filter === "text" ? "active" : ""}`}
              onClick={() => setFilter("text")}
            >
              Written Reviews (5)
            </button>
          </div>
        </div>

        {/* Stories Cards Grid */}
        <div className="testimonials-cards-grid">
          {currentStories.map((story) => (
            <article key={story.id} className="patient-story-card">
              {story.type === "video" && story.videoUrl ? (
                <div className="story-video-container">
                  <iframe
                    src={story.videoUrl}
                    title={`Patient Story - ${story.name}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="story-video-iframe"
                  ></iframe>
                </div>
              ) : null}

              <div className="story-body">
                {/* Rating Stars */}
                <div className="story-rating" aria-label="5 star rating">
                  {"★".repeat(story.rating)}
                </div>

                <p className="story-quote">“{story.message}”</p>

                <div className="story-footer">
                  <div className="story-avatar">
                    {story.name.charAt(0)}
                  </div>
                  <div className="story-author-info">
                    <h4 className="story-author-name">{story.name}</h4>
                    <p className="story-author-role">{story.role}</p>
                  </div>
                  <span className="story-verified-badge" title="Verified Patient">
                    ✓ Verified Care
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Navigation Controls */}
        <div className="testimonials-controls">
          <div className="testimonials-dots">
            {Array.from({ length: totalPages }).map((_, idx) => (
              <button
                key={idx}
                type="button"
                className={`dot-btn ${idx === currentIndex ? "active" : ""}`}
                onClick={() => setCurrentIndex(idx)}
                aria-label={`Go to slide page ${idx + 1}`}
              />
            ))}
          </div>

          <div className="testimonials-nav-buttons">
            <button
              type="button"
              className="nav-arrow-btn"
              onClick={handlePrev}
              aria-label="Previous testimonials"
            >
              ←
            </button>
            <span className="page-indicator">
              Page {currentIndex + 1} of {totalPages || 1}
            </span>
            <button
              type="button"
              className="nav-arrow-btn"
              onClick={handleNext}
              aria-label="Next testimonials"
            >
              →
            </button>
          </div>
        </div>

        {/* Google Reviews Trust Bar */}
        <div className="testimonials-trust-bar">
          <div className="trust-stat">
            <span className="trust-number">4.8 / 5.0</span>
            <span className="trust-label">Google Rating</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-stat">
            <span className="trust-number">90%+</span>
            <span className="trust-label">Normal Delivery Success</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-stat">
            <span className="trust-number">1,50,000+</span>
            <span className="trust-label">Families Welcomed</span>
          </div>
        </div>
      </div>
    </section>
  );
}
